import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@material-ui/pickers';

const CustomDatePicker = ({
  isDisabled,
  isMandatory,
  markIfUnselected,
  value,
  ...props
}) => {
  const [isVisited, setIsVisited] = useState(false);
  const shouldMarkRed =
    ((isMandatory && isVisited) || markIfUnselected) && !value && !isDisabled;
  return (
    <DatePicker
      error={shouldMarkRed}
      onBlur={() => setIsVisited(true)}
      style={{ borderColor: 'red', boxShadow: '0px' }}
      value={value}
      {...props}
    />
  );
};

CustomDatePicker.propTypes = {
  isDisabled: PropTypes.bool,
  isMandatory: PropTypes.bool,
  markIfUnselected: PropTypes.bool,
  value: PropTypes.object,
};

export default CustomDatePicker;
